import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PolicyPage from './PolicyPage';

/**
 * Central das políticas da Empiria.
 *
 * O rodapé, o menu do header, o cadastro, o login e o chatbot apontam para cá
 * em vez de irem direto aos Termos: são seis documentos, e mandar o usuário a
 * um deles deixava os outros cinco sem porta de entrada.
 *
 * A Política de Segurança Cibernética é a única listada em versão resumida: o
 * documento aprovado descreve a organização interna da Empiria e os controles
 * do ambiente de tecnologia. Ela precisa estar aqui de todo modo, porque o
 * item 10.1 da Política de Cookies e Privacidade manda o titular acessá-la.
 */
const DOCUMENTOS = [
    {
        titulo: 'Termos Gerais de Uso',
        descricao: 'As regras que regem o uso da plataforma, para anfitriões e convivas.',
        para: '/termos',
    },
    {
        titulo: 'Política de Cookies e Privacidade',
        descricao: 'Quais dados a Empiria trata, por quê, e os seus direitos sobre eles.',
        para: '/privacidade',
    },
    {
        titulo: 'Política Geral de Compra e Pagamento',
        descricao: 'Pagamento, taxas, parcelamento, reembolso e direito de arrependimento.',
        para: '/politicas/compra-e-pagamento',
    },
    {
        titulo: 'Política Geral de Uso Responsável',
        descricao: 'O que não pode ser oferecido como encontro na plataforma.',
        para: '/politicas/uso-responsavel',
    },
    {
        titulo: 'Política de Segurança Cibernética e da Informação',
        descricao: 'Como a Empiria protege os dados que você confia à plataforma.',
        para: '/politicas/seguranca',
    },
    {
        titulo: 'Glossário',
        descricao: 'O significado dos termos iniciados por letra maiúscula nos documentos.',
        para: '/glossario',
    },
];

const Policies = () => {
    const navigate = useNavigate();

    return (
        <PolicyPage
            titulo="Políticas da Empiria"
            versao="Os documentos que regem o uso da plataforma"
        >
            <Stack spacing={1.5}>
                {DOCUMENTOS.map(documento => (
                    <Stack
                        key={documento.para}
                        direction="row"
                        alignItems="center"
                        spacing={1.5}
                        onClick={() => navigate(documento.para)}
                        sx={{
                            border: '1px solid #eee',
                            borderRadius: '12px',
                            p: 2,
                            cursor: 'pointer',
                            transition: 'background-color 0.15s, border-color 0.15s',
                            '&:hover': { bgcolor: '#f7fbfa', borderColor: '#006a61' },
                        }}
                    >
                        <Box sx={{ flexGrow: 1 }}>
                            <Typography variant="subtitle1" fontWeight={600} color="#006a61">
                                {documento.titulo}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {documento.descricao}
                            </Typography>
                        </Box>
                        <ChevronRightIcon sx={{ color: '#006a61' }} />
                    </Stack>
                ))}
            </Stack>
        </PolicyPage>
    );
};

export default Policies;
